import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { Router } from '@angular/router';
import { KYMW7301Model } from './kymw7301.model';
import { GetCouponService } from './api-services/get-coupon.service';
import { mode } from '../kymw7300/kymw7300.component';
import { NotNullTextInputComponent } from './../../../commons/kymw02/not-null-text-input/not-null-text-input.component';
import { CheckboxLabelComponent } from './../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { CodeComboBoxComponent } from './../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { AddCouponService } from './api-services/add-coupon.service';
import { UpdateCouponService } from './api-services/update-coupon.service';
import { GetReceiptCatalogService } from './api-services/get-receipt-catalog.service';

/**
 * 注文単位値引クーポン登録画面を管理するクラス
 *
 * @export KYMW7301Component
 * @class KYMW7301Component
 */
@Component({
  selector: 'app-kymw7301',
  templateUrl: 'kymw7301.component.html',
  styleUrls: ['kymw7301.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW7301Component extends PlessViewHelperSub implements OnInit {
  public model: KYMW7301Model = new KYMW7301Model();

  // 元の画面への連携用Function
  public callbackRegist: Function;

  isComposing = false;

  @ViewChild('cmb_CouponCategory', { static: true }) cmb_CouponCategory: CodeComboBoxComponent;
  @ViewChild('txti_CouponOrderCd', { static: true }) txti_CouponOrderCd: ElementRef;
  @ViewChild('txti_CouponIssueCatalogStart', { static: true }) txti_CouponIssueCatalogStart: NotNullTextInputComponent;
  @ViewChild('chb_TypeItem', { static: true }) chb_TypeItem: CheckboxLabelComponent;
  @ViewChild('chb_TypeMail', { static: true }) chb_TypeMail: CheckboxLabelComponent;
  @ViewChild('txti_StartMemberWeek', { static: true }) txti_StartMemberWeek: ElementRef;
  @ViewChild('txti_EndMemberWeek', { static: true }) txti_EndMemberWeek: ElementRef;
  @ViewChild('txti_CouponIssueCatalogEnd', { static: true }) txti_CouponIssueCatalogEnd: NotNullTextInputComponent;
  @ViewChild('txti_CouponReceiptCatalogEnd', { static: true }) txti_CouponReceiptCatalogEnd: NotNullTextInputComponent;
  @ViewChild('cmb_CpgrpCd', { static: true }) cmb_CpgrpCd: CodeComboBoxComponent;
  @ViewChild('txti_ValidWeek', { static: true }) txti_ValidWeek: NotNullTextInputComponent;

  /** クーポン種別が05の場合にtrue、画面の全入力項目を非活性にする */
  public isCouponCategory05: boolean = false;
  /** クーポン種別一時保存用 */
  public preCouponCategory: string = '';
  
  /**
   * Creates an instance of KYMW7301Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW7301Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    // private route: ActivatedRoute,
    private router: Router,
    private getCouponService: GetCouponService,
    private addCouponService: AddCouponService,
    private updateCouponService: UpdateCouponService,
    private render: Renderer2,
    private getReceiptCatalogService: GetReceiptCatalogService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof kymw7301Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7301';
  }

  ngAfterViewInit() {
    this.setChangeEvent();
  }

  /**
   * 親画面から値を設定する
   * @param mode モード（1:新規/2:編集）
   * @param couponGoodsNo クーポン商品連番
   * @param couponReceiptCatalogStart 受付期間(開始) 
   */
  public setParams(mode: string, couponGoodsNo: string, couponReceiptCatalogStart: string): void {
    // 遷移元からのパラメータ取得
    if (mode) {
      this.model.mode = mode;
    }
    if (couponGoodsNo) {
      this.model.couponGoodsNo = couponGoodsNo;
    }
    if (couponReceiptCatalogStart) {
      this.model.couponReceiptCatalogStart = couponReceiptCatalogStart;
    }

    if (!PlessViewUtilsSub.isEmpty(this.model.couponGoodsNo)) {
      // 検索実行
      this.getCouponService.execute(this.model, () => {
        this.getCouponResult();
      });
    } else {
      this.chb_TypeItem.disabled = true;
      this.chb_TypeMail.disabled = true;
      this.model.allCoop = true;
      this.eventChangeHandler_AllCoop();
      this.eventChangeHandler_UseStandardPrice();
    }
  }

  private setChangeEvent() {
    const fieldIds = [
      'cmb_CouponCategory',
      'txti_CouponOrderCd',
      'cmb_NoticeExistenceType',
      'cmb_CpgrpCd',
      'chb_TypeItem',
      'chb_TypeMail',
      'txti_UseStandardPrice',
      'txti_StartMemberWeek',
      'txti_EndMemberWeek',
      'txti_CouponIssueCatalogStart',
      'txti_CouponIssueCatalogEnd',
      'txti_CouponReceiptCatalogStart',
      'txti_CouponReceiptCatalogEnd',
      'txti_ValidWeek',
      'txti_DiscountPrice',
      'txti_CouponName',
      'txti_CouponNameKana',
      'chk_AllCoop',
      'chk_Ibaraki',
      'chk_Tochigi',
      'chk_Gunma',
      'chk_Chiba',
      'chk_Saitama',
      'chk_Tokyo',
      'chk_Nagano',
      'chk_Niigata',
      'txti_EcTitle',
      'txti_DetailsTitle',
      'txti_UseTerms',
      'txti_DiscountedAmount',
      'txti_ValidatedDate',
    ];
    fieldIds.forEach(fieldId => {
      document.getElementById(fieldId).addEventListener('change', () => {
        if (fieldId === "cmb_CouponCategory") {
          this.model.couponCategoryChangeFlg = "1";
        }
        if (fieldId !== "txti_CouponIssueCatalogEnd" && fieldId !== "txti_CouponReceiptCatalogEnd") {
          this.model.changeOtherCatalogEndFlg = "1";
        }
      });
    });
  }

  /**
   * 注文単位値引クーポン情報取得後の処理
   */
  private getCouponResult() {
    if (this.model.mode === mode.NewMode) {
      // 新規作成の場合、クーポン発行期間・受付期間を未設定
      this.model.couponIssueCatalogStart = '';
      this.model.couponIssueCatalogEnd = '';
      this.model.couponReceiptCatalogStart = '';
      this.model.couponReceiptCatalogEnd = '';
    } else if (this.model.mode === mode.EditMode) {
      // 編集の場合
      this.txti_CouponIssueCatalogStart.disabled = true;
    }

    if (this.model.couponCategory === '01') {
      // クーポン種別が01：２名グループ利用値引の場合
      this.cmb_CpgrpCd.disabled = true;
      this.txti_ValidWeek.disabled = true;
    } else if (this.model.couponCategory === '02') {
      // クーポン種別が02：３名以上グループ利用値引の場合
      this.cmb_CpgrpCd.disabled = true;
      this.txti_ValidWeek.disabled = true;
    } else if (this.model.couponCategory === '03') {
      // クーポン種別が03：新規加入者クーポンの場合
      this.cmb_CpgrpCd.disabled = true;
      this.render.addClass(this.txti_StartMemberWeek.nativeElement, 'text-label-required');
      this.render.addClass(this.txti_EndMemberWeek.nativeElement, 'text-label-required');
    } else if (this.model.couponCategory === '04') {
      // クーポン種別が04：アップロードの場合
      this.txti_StartMemberWeek.nativeElement.disabled = true;
      this.txti_EndMemberWeek.nativeElement.disabled = true;
      this.txti_CouponIssueCatalogEnd.disabled = true;
    }

    // クーポン種別が05：クーポンチラシの場合、入力項目を全て非活性にする
    this.isCouponCategory05 = this.model.couponCategory === '05';
    // クーポン種別変更時イベント用に初期値を保持する。
    this.preCouponCategory = this.model.couponCategory;

    for (const coopCode of this.model.coopCodeList) {
      this.setCoopCode(coopCode);
    }

    if (this.model.coopCodeList.length === 8) {
      this.model.allCoop = true;
    } else {
      this.model.allCoop = false;
    }

    if (this.model.noticeExistenceType === '1') {
      if (this.model.noticeMethodTypeItem === '1') {
        this.model.typeItem = true;
      } else {
        this.model.typeItem = false;
      }
      if (this.model.noticeMethodTypeMail === '1') {
        this.model.typeMail = true;
      } else {
        this.model.typeMail = false;
      }
    } else {
      this.chb_TypeItem.disabled = true;
      this.chb_TypeMail.disabled = true;
    }
  }

  /**
   * 生協コードのチェックを行う。
   **/
  private setCoopCode(coopCode: string) {
    if (coopCode === this.kymw00Model.COOP_CODE_IB) {
      this.model.ibaraki = true;	// いばらき
    } else if (coopCode === this.kymw00Model.COOP_CODE_TO) {
      this.model.tochigi = true;	// とちぎ
    } else if (coopCode === this.kymw00Model.COOP_CODE_GU) {
      this.model.gunma = true;	// ぐんま
    } else if (coopCode === this.kymw00Model.COOP_CODE_TI) {
      this.model.chiba = true;	// ちば
    } else if (coopCode === this.kymw00Model.COOP_CODE_SA) {
      this.model.saitama = true;	// さいたま
    } else if (coopCode === this.kymw00Model.COOP_CODE_TK) {
      this.model.tokyo = true;	// とうきょう
    } else if (coopCode === this.kymw00Model.COOP_CODE_NA) {
      this.model.nagano = true;	// ながの
    } else if (coopCode === this.kymw00Model.COOP_CODE_NI) {
      this.model.niigata = true;	// にいがた
    }
  }

  /**
   * クーポン種別変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_CouponCategory(): void {
    if (this.model.couponCategory === '01') {
      // クーポン種別が01：２名グループ利用値引の場合
      this.txti_StartMemberWeek.nativeElement.disabled = false;
      this.render.removeClass(this.txti_StartMemberWeek.nativeElement, 'text-label-required');
      this.txti_EndMemberWeek.nativeElement.disabled = false;
      this.render.removeClass(this.txti_EndMemberWeek.nativeElement, 'text-label-required');
      this.txti_CouponIssueCatalogEnd.disabled = false;
      this.cmb_CpgrpCd.disabled = true;
      this.txti_ValidWeek.disabled = true;

      this.model.cpgrpCd = '9';
      this.model.validWeek = '1';
      this.changeCouponIssueCatalogEndAndValidWeek();
    } else if (this.model.couponCategory === '02') {
      // クーポン種別が02：３名以上グループ利用値引の場合
      this.txti_StartMemberWeek.nativeElement.disabled = false;
      this.render.removeClass(this.txti_StartMemberWeek.nativeElement, 'text-label-required');
      this.txti_EndMemberWeek.nativeElement.disabled = false;
      this.render.removeClass(this.txti_EndMemberWeek.nativeElement, 'text-label-required');
      this.txti_CouponIssueCatalogEnd.disabled = false;
      this.cmb_CpgrpCd.disabled = true;
      this.txti_ValidWeek.disabled = true;

      this.model.cpgrpCd = '9';
      this.model.validWeek = '1';
      this.changeCouponIssueCatalogEndAndValidWeek();
    } else if (this.model.couponCategory === '03') {
      // クーポン種別が03：新規加入者クーポンの場合
      this.txti_StartMemberWeek.nativeElement.disabled = false;
      this.render.addClass(this.txti_StartMemberWeek.nativeElement, 'text-label-required');
      this.txti_EndMemberWeek.nativeElement.disabled = false;
      this.render.addClass(this.txti_EndMemberWeek.nativeElement, 'text-label-required');
      this.txti_CouponIssueCatalogEnd.disabled = false;
      this.cmb_CpgrpCd.disabled = true;
      this.txti_ValidWeek.disabled = false;

      this.model.cpgrpCd = '9';
    } else if (this.model.couponCategory === '04') {
      // クーポン種別が04：アップロードの場合
      this.txti_StartMemberWeek.nativeElement.disabled = true;
      this.render.removeClass(this.txti_StartMemberWeek.nativeElement, 'text-label-required');
      this.txti_EndMemberWeek.nativeElement.disabled = true;
      this.render.removeClass(this.txti_EndMemberWeek.nativeElement, 'text-label-required');
      this.txti_CouponIssueCatalogEnd.disabled = true;
      this.cmb_CpgrpCd.disabled = false;
      this.txti_ValidWeek.disabled = false;

      this.model.startMemberWeek = '';
      this.model.endMemberWeek = '';
      this.model.couponIssueCatalogEnd = '';
      this.model.couponReceiptCatalogEnd = '';
      this.model.validatedDate = '';
      // クーポン発行期間（開始）の入力完了イベント発火
      this.eventChangeHandler_CouponIssueCatalogStart();
    } else if (this.model.couponCategory === '05') {
      // クーポン種別が05：クーポンチラシの場合
      const message = this.model.mode === mode.NewMode ? '登録' : '変更';
      this.dialogService.openAlertGetMessage('E0660', [message]);
      // 変更前に戻す
      this.model.couponCategory = this.preCouponCategory;
    }
    this.preCouponCategory = this.model.couponCategory;
  }

  /**
   * 通知有無区分変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_NoticeExistenceType(): void {
    if (this.model.noticeExistenceType === '1') {
      this.chb_TypeItem.disabled = false;
      this.chb_TypeMail.disabled = false;
    } else {
      this.chb_TypeItem.disabled = true;
      this.chb_TypeMail.disabled = true;

      this.model.typeItem = false;
      this.model.typeMail = false;
    }
  }

  /**
   * お届け明細チェックボックス変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_TypeItem() {
    if (this.model.typeItem) {
      this.model.detailsTitle = this.model.ecTitle;
    } else {
      this.model.detailsTitle = '';
    }
  }

  /**
   * 利用基準金額変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_UseStandardPrice() {
    if (PlessViewUtilsSub.isEmpty(this.model.useStandardPrice)) {
      this.model.useTerms = '有効期限内で一回限りご利用できます';
    } else {
      this.model.useTerms = '一回のご利用金額（本体）'
        .concat(PlessViewUtilsSub.halfToFull(Number(this.model.useStandardPrice).toLocaleString()))
        .concat('円以上で');
    }
  }

  /**
   * クーポン発行期間（開始）変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_CouponIssueCatalogStart() {
    if (this.model.couponIssueCatalogStart.length == 8) {
      // 受付期間（開始）の取得処理
      this.getReceiptCatalogService.execute(this.model, this.model.couponIssueCatalogStart, "1", 0, () => {
        this.model.couponIssueCatalogEnd = this.model.couponIssueCatalogStart;
        this.changeCouponIssueCatalogEndAndValidWeek();
      });
    } else {
      this.model.couponReceiptCatalogStart = "";
    }
  }

  /**
   * クーポン発行期間（終了）変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_CouponIssueCatalogEnd() {
    this.changeCouponIssueCatalogEndAndValidWeek();
  }

  /**
   * 有効週変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_ValidWeek() {
    this.changeCouponIssueCatalogEndAndValidWeek();
  }

  /**
   * クーポン発行期間（終了）と有効週変更時の処理。
   **/
  private changeCouponIssueCatalogEndAndValidWeek() {
    if (!PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogEnd)
        && !PlessViewUtilsSub.isEmpty(this.model.validWeek)) {
      // クーポン発行期間（終了）かつ有効週が入力ありの場合
      if (this.model.couponIssueCatalogEnd.length == 8) {
        if (this.model.couponIssueCatalogEnd === '99999999') {
          this.model.couponReceiptCatalogEnd = '99999999';
          this.setValidatedDate();
        } else {
          // 受付期間（終了）の取得処理
          this.getReceiptCatalogService.execute(this.model, this.model.couponIssueCatalogEnd, "0", Number(this.model.validWeek), () => {
            this.setValidatedDate();
          });
        }
      } else {
        this.model.couponReceiptCatalogEnd = '';
        this.model.validatedDate = '';
      }
    } else {
      // クーポン発行期間（終了）または有効週が未入力の場合
      if (this.model.couponIssueCatalogEnd === '99999999') {
        this.model.couponReceiptCatalogEnd = '99999999';
      } else {
        this.model.couponReceiptCatalogEnd = '';
      }
      this.model.validatedDate = '';
    }
  }

  /**
   * 有効期限の設定処理。
   **/
  private setValidatedDate() {
    const year = this.model.couponReceiptCatalogEnd.substring(0, 4);
    let month = this.model.couponReceiptCatalogEnd.substring(4, 6);
    if ('0' === month.charAt(0)) {
      // 1文字目が0の場合、1文字目を削除
      month = month.substring(1, 2);
    }

    let time = this.model.couponReceiptCatalogEnd.substring(6, 8);
    if ('0' === time.charAt(0)) {
      // 1文字目が0の場合、1文字目を削除
      time = time.substring(1, 2);
    }

    if (this.model.validWeek === '1') {
      this.model.validatedDate = PlessViewUtilsSub.halfToFull(year)
        .concat('年')
        .concat(PlessViewUtilsSub.halfToFull(month))
        .concat('月')
        .concat(PlessViewUtilsSub.halfToFull(time))
        .concat('回のご注文のみ有効');
    } else {
      this.model.validatedDate = '有効期限　'
        .concat(PlessViewUtilsSub.halfToFull(year))
        .concat('年')
        .concat(PlessViewUtilsSub.halfToFull(month))
        .concat('月')
        .concat(PlessViewUtilsSub.halfToFull(time))
        .concat('回まで');
    }
  }

  /**
   * 値引単価変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_DiscountPrice() {
    if (PlessViewUtilsSub.isEmpty(this.model.discountPrice)) {
      this.model.discountedAmount = '';
    } else {
      this.model.discountedAmount = PlessViewUtilsSub.halfToFull(Number(this.model.discountPrice).toLocaleString())
        .concat('円引きクーポン');
    }
  }

  /**
   * ALLチェックボックス変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_AllCoop() {
    if (this.model.allCoop) {
      this.model.ibaraki = true;
      this.model.tochigi = true;
      this.model.gunma = true;
      this.model.chiba = true;
      this.model.saitama = true;
      this.model.tokyo = true;
      this.model.nagano = true;
      this.model.niigata = true;
    } else {
      this.model.ibaraki = false;
      this.model.tochigi = false;
      this.model.gunma = false;
      this.model.chiba = false;
      this.model.saitama = false;
      this.model.tokyo = false;
      this.model.nagano = false;
      this.model.niigata = false;
    }
  }

  /**
   * 生協コードチェックボックス変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_CoopCode() {
    if (this.model.ibaraki
      && this.model.tochigi
      && this.model.gunma
      && this.model.chiba
      && this.model.saitama
      && this.model.tokyo
      && this.model.nagano
      && this.model.niigata
    ) {
      this.model.allCoop = true;
    } else {
      this.model.allCoop = false;
    }
  }

  /**
   * タイトル（ＥＣ）変更時に呼び出されるメソッド。
   */
  public eventChangeHandler_EcTitle() {
    if (this.model.typeItem) {
      this.model.detailsTitle = this.model.ecTitle;
    }
  }

  /**
   * 登録ボタン押下時に呼び出されるメソッド。
   */
  public eventEntry_CLICKHandler() {
    // バリデーションチェック処理
    if (!this.validateCoupon()) {
      this.dialogService.openAlertGetMessage('Q0164', ['注文単位値引クーポン'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          // 業務チェック処理
          if (!this.checkCoupon()) {
            // チェックボックス項目のコード値を取得
            this.model.coopCodeList = this.getCoopCodeArray();
            this.model.noticeMethodTypeItem = this.getTypeItem();
            this.model.noticeMethodTypeMail = this.getTypeMail();
            if (this.model.mode === mode.NewMode) {
              // 登録処理
              this.addCouponService.execute(this.model, () => {
                this.dialogService.openAlertGetMessage('I0106', ['登録が完了'], () => {
                  // 注文単位値引クーポン一覧画面に遷移(自画面閉じる)
                  this.callbackRegist();
                  this.closeFunction();
                });
              });
            } else if (this.model.mode === mode.EditMode) {
              // 更新処理
              this.updateCouponService.execute(this.model, () => {
                this.dialogService.openAlertGetMessage('I0106', ['登録が完了'], () => {
                  // 注文単位値引クーポン一覧画面に遷移(自画面閉じる)
                  this.callbackRegist();
                  this.closeFunction();
                });
              });
            }
          }
        }
      });
    }
  }

  /**
   * バリデーションチェックメソッド
   */
  private validateCoupon(): boolean {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(this.model.couponCategory)) {
      this.dialogService.openAlertGetMessage('W0001', ['クーポン種別'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.noticeExistenceType)) {
      this.dialogService.openAlertGetMessage('W0001', ['通知有無区分'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogStart)) {
      this.dialogService.openAlertGetMessage('W0001', ['クーポン発行期間（開始）'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.cpgrpCd)) {
      this.dialogService.openAlertGetMessage('W0001', ['グループ'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.validWeek)) {
      this.dialogService.openAlertGetMessage('W0001', ['有効週'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.discountPrice)) {
      this.dialogService.openAlertGetMessage('W0001', ['値引単価'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.couponName)) {
      this.dialogService.openAlertGetMessage('W0001', ['クーポン名'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.couponNameKana)) {
      this.dialogService.openAlertGetMessage('W0001', ['クーポン名(ｶﾅ)'], null);
      return true;
    } else if (!this.model.ibaraki
        && !this.model.tochigi
        && !this.model.gunma
        && !this.model.chiba
        && !this.model.saitama
        && !this.model.tokyo
        && !this.model.nagano
        && !this.model.niigata) {
      this.dialogService.openAlertGetMessage('W0001', ['利用生協'], null);
      return true;
    } else if (PlessViewUtilsSub.isEmpty(this.model.ecTitle)) {
      this.dialogService.openAlertGetMessage('W0001', ['タイトル（EC）'], null);
      return true;
    }

    // クーポン種別関連の条件付き必須チェック
    if (this.model.couponCategory === '01' || this.model.couponCategory === '02') {
      if (PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogEnd)) {
        this.dialogService.openAlertGetMessage('W0001', ['クーポン発行期間（終了）'], null);
        return true;
      }
    } else if (this.model.couponCategory === '03') {
      if (PlessViewUtilsSub.isEmpty(this.model.startMemberWeek)) {
        this.dialogService.openAlertGetMessage('W0001', ['加入週数（開始）'], null);
        return true;
      } else if (PlessViewUtilsSub.isEmpty(this.model.endMemberWeek)) {
        this.dialogService.openAlertGetMessage('W0001', ['加入週数（終了）'], null);
        return true;
      } else if (PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogEnd)) {
        this.dialogService.openAlertGetMessage('W0001', ['クーポン発行期間（終了）'], null);
        return true;
      }
    }

    // 通知有無区分関連の条件付き必須チェック
    if (this.model.noticeExistenceType === '1') {
      if (!this.model.typeItem && !this.model.typeMail) {
        this.dialogService.openAlertGetMessage('W0001', ['通知方法区分'], null);
        return true;
      }
    }

    // 桁数チェック（桁数イコール）
    if (!PlessViewUtilsSub.isEmpty(this.model.couponOrderCd)
        && this.model.couponOrderCd.length !== 6) {
      this.dialogService.openAlertGetMessage('W0005', ['クーポン注文コード', '6'], null);
      return true;
    } else if (!PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogStart)
        && this.model.couponIssueCatalogStart.length !== 8) {
      this.dialogService.openAlertGetMessage('W0005', ['クーポン発行期間（開始）', '8'], null);
      return true;
    } else if (!PlessViewUtilsSub.isEmpty(this.model.couponIssueCatalogEnd)
        && this.model.couponIssueCatalogEnd.length !== 8) {
      this.dialogService.openAlertGetMessage('W0005', ['クーポン発行期間（終了）', '8'], null);
      return true;
    }

    // 最小値チェック
    if (!PlessViewUtilsSub.isEmpty(this.model.useStandardPrice) && Number(this.model.useStandardPrice) < 1) {
      this.dialogService.openAlertGetMessage('E0142', ['利用基準金額', '1'], null);
      return true;
    }
    if (!PlessViewUtilsSub.isEmpty(this.model.startMemberWeek) && Number(this.model.startMemberWeek) < 1) {
      this.dialogService.openAlertGetMessage('E0142', ['加入週数（開始）', '1'], null);
      return true;
    }
    if (!PlessViewUtilsSub.isEmpty(this.model.validWeek) && Number(this.model.validWeek) < 1) {
      this.dialogService.openAlertGetMessage('E0142', ['有効週', '1'], null);
      return true;
    }

    return false;
  }

  /**
   * 業務チェックメソッド
   */
  private checkCoupon(): boolean {
    if (Number(this.model.startMemberWeek) > Number(this.model.endMemberWeek)) {
      this.dialogService.openAlertGetMessage('E0525', [], null);
      return true;
    }

    if (Number(this.model.couponIssueCatalogStart) > Number(this.model.couponIssueCatalogEnd)) {
      this.dialogService.openAlertGetMessage('E0123', ['クーポン発行期間'], null);
      return true;
    }

    if (this.model.couponCategory === '01' || this.model.couponCategory === '02') {
      if (Number(this.model.discountPrice) < 1) {
        this.dialogService.openAlertGetMessage('E0528', [], null);
        return true;
      }
    }

    return false;
  }

  /**
   * 生協コードを取得
   * チェックされた生協のみArrayにセットし返却
   **/
  private getCoopCodeArray(): string[] {
    const returnArray: string[] = [];
    if (this.model.ibaraki) {
      returnArray.push(this.kymw00Model.COOP_CODE_IB);	// いばらき
    }
    if (this.model.tochigi) {
      returnArray.push(this.kymw00Model.COOP_CODE_TO);	// とちぎ
    }
    if (this.model.gunma) {
      returnArray.push(this.kymw00Model.COOP_CODE_GU);	// ぐんま
    }
    if (this.model.chiba) {
      returnArray.push(this.kymw00Model.COOP_CODE_TI);	// ちば
    }
    if (this.model.saitama) {
      returnArray.push(this.kymw00Model.COOP_CODE_SA);	// さいたま
    }
    if (this.model.tokyo) {
      returnArray.push(this.kymw00Model.COOP_CODE_TK);	// とうきょう
    }
    if (this.model.nagano) {
      returnArray.push(this.kymw00Model.COOP_CODE_NA);	// ながの
    }
    if (this.model.niigata) {
      returnArray.push(this.kymw00Model.COOP_CODE_NI);	// にいがた
    }
    return returnArray;
  }

  /**
   * お届け明細のコード値を取得
   **/
  private getTypeItem(): string {
    let result: string;
    if (this.model.typeItem) {
      result = '1';
    } else {
      result = '0';
    }
    return result;
  }

  /**
   * メルマガのコード値を取得
   **/
  private getTypeMail(): string {
    let result: string;
    if (this.model.typeMail) {
      result = '1';
    } else {
      result = '0';
    }
    return result;
  }

  /**
   * クーポン名(ｶﾅ)の入力から半角カンマを削除
   */
  public eventCouponNameKana_deleteCommaHandler(): void {
    this.model.couponNameKana = this.model.couponNameKana.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
